// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"c84ee84b","364":"281b96e4","469":"c84ee84b","593":"c84ee84b","696":"815d38fb","729":"c84ee84b","843":"c84ee84b"}[chunkId] + ".chunk.css";
};